/** How big are the section gaps between each component, and between the sides of the page. */
export const SECTION_GAP = 3.5 * 2; // 28px * 2 in MUI
